interface PointsListProps {
  points: string[];
  header: string;
}

function PointsList({ points, header }:PointsListProps) {
  return (
    <div className="nhsuk-hint nhsuk-u-margin-left-2">
      <p className="nhsuk-u-margin-left-1">{header}</p>
      <ul className="nhsuk-u-margin-left-3">
        {points.map((point: string) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
    </div>
  );
}

export default PointsList;
